import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function OverviewIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 36} height={height || 36} viewBox="0 0 36 36">
      <g data-name="Ellipse 76" fill="none" stroke="#bbb" strokeWidth={1.5}>
        <circle cx={18} cy={18} r={18} stroke="none" />
        <circle cx={18} cy={18} r={17.25} />
      </g>
      <path
        data-name="Path 10041"
        d="M14.531-1.875H1.875v-8.906a.469.469 0 00-.469-.469H.469a.469.469 0 00-.469.469v9.844A.938.938 0 00.937 0h13.594A.469.469 0 0015-.469v-.937a.469.469 0 00-.469-.469zm-.937-8.437h-3.459a.7.7 0 00-.5 1.2l.949.949-2.15 2.15-2.15-2.15a.937.937 0 00-1.326 0L2.95-6.15a.469.469 0 000 .663l.663.663a.469.469 0 00.663 0l1.349-1.35 2.15 2.15a.937.937 0 001.326 0l2.812-2.812.949.949a.7.7 0 001.2-.5v-3.457a.468.468 0 00-.468-.468z"
        transform="translate(11 23.25)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
